var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar__logo-section"},[_c('a',{staticClass:"navbar__logo-link",attrs:{"href":"/"}},[_c('span',{staticClass:"navbar__logo-svg logo--wcmc"},[_c('logo-wcmc')],1),_vm._v(" "),_c('h4',{staticClass:"navbar__logo-callout",domProps:{"textContent":_vm._s(_vm.logoCalloutText)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }